import {defineStore} from 'pinia'
import {ErrorMessageBag} from "@/stores/errors/ErrorMessageBag.ts";
import {PupilActivity} from "@/models/PupilActivity.model";
import {orgApi} from "@/utils/Api.util";
import { format } from 'date-fns'
import {Pupil} from "@/models/Pupil.model";
import {useClassroomsStore} from "@/stores/Classrooms.store";
import { Goal } from '@/models/Goal.model';

interface ObservationStoreState {
	errors: ErrorMessageBag | null,
	loadedDates: {
		[ date: string ] : PupilActivity[]
	}
}

export const usePupilActivitiesStore = defineStore('pupilActivities', {

	state: (): ObservationStoreState => ({
		errors: null,
		loadedDates: {}
	}),

	getters: {
		getActivityForPupilOnDate: (state) => {
			return (date: Date, pupil: Pupil) => {

				if (!state.loadedDates[format(date, 'yyyy-MM-dd')]) {
					return [];
				}

				return state.loadedDates[format(date, 'yyyy-MM-dd')]
					.filter(activity => activity.pupil.id === pupil.id);

			};
		},

		loadedGoals: (state) => {
			const goals: Goal[] = [];

			for (const date in state.loadedDates) {
				if (state.loadedDates[date]) {
					state.loadedDates[date].forEach((activity: PupilActivity) => {
						if (!activity?.lessonItem?.lessonPlan) {
							return;
						}

						activity.lessonItem.lessonPlan.goals.forEach(goal => {
							goals.push(goal);
						});
					});
				}
			}

			return goals;
		},
	},

	actions: {

		async loadActivityOnDate(date: Date) {
			const response = await orgApi.get("pupil-activities", {
				params: {
					classroomIds: useClassroomsStore().getCurrentClassroom().id,
					mask: [
						'id',
						'checkin',
						'checkout',
						'pupil_feedback',
						'lessonItem.*',
						'lessonItem.icon.*',
						'pupil.*',
						'lessonItem.lessonPlan.*',
						'lessonItem.lessonPlan.goals.*',
						'activity.*',
					].join(','),
					date: format(date, 'yyyy-MM-dd')
				}
			});

			// don't use line below, the mapping function being used here has a 2nd argument which the map() function fills with the array index
			// this.loadedDates[format(date, 'yyyy-MM-dd')] = response.data.data.map(PupilActivity.mapFromServer);
			this.loadedDates[format(date, 'yyyy-MM-dd')] = response.data.data.map( obj => (new PupilActivity()).setFromServerData(obj) );
		}

	}
});
